'use client';

import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';

/**
 * Client-only mapping from game slug → its lazily-loaded component.
 *
 * `next/dynamic` with `ssr: false` is only permitted inside Client Components,
 * which is why this module is separated from the pure `registry.ts` metadata.
 */

function Loading() {
  return <div className="play-loading">Loading…</div>;
}

const StackTowerGame = dynamic(() => import('../ui/game-client'), {
  ssr: false,
  loading: Loading,
});

const Game2048 = dynamic(() => import('./g2048/g2048-game'), {
  ssr: false,
  loading: Loading,
});

const COMPONENTS: Record<string, ComponentType> = {
  'stack-tower': StackTowerGame,
  '2048': Game2048,
};

export function GameComponent({ slug }: { slug: string }) {
  const Component = COMPONENTS[slug];
  if (!Component) return null;
  return <Component />;
}
